import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticatedUser, SideNavCollection, AuthenticationService } from '@aveva/connect-web-core';
import { AccountWithIcon } from './account-with-icon';
import { AccountsService } from '../services/accounts.service';
import { Subject, debounceTime, first, firstValueFrom, from } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ImportErrorsComponent } from './import/import-errors/import-errors.component';
import * as globals from './globals';
import { LoggingService } from '../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-training',
  templateUrl: './training.component.html',
  styleUrls: ['./training.component.css']
})
export class TrainingComponent implements OnInit{
  get links(): SideNavCollection[] {
    return this._links;
  }

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private accountsService: AccountsService,
    private logger: LoggingService) { }

  ngOnInit() {
    this.route.data
      .subscribe((data: { user: AuthenticatedUser, account: AccountWithIcon }) => {
        this.user = data.user;
        this.account = data.account;
      });

    this.validateAccount();
  }

  private validateAccount(){
    this.accountsService.isAccountUserAccess(this.user?.email.toLowerCase()).subscribe({
      next: (data) => {

        this.updateLinks();

        this.updateLinks$.pipe(debounceTime(200)).subscribe(() => {
          this.updateLinks();
        });

        this.isTrainerAdmin = (localStorage.getItem(globals.POLICIES) === `${globals.TC}:${globals.trainingadmin}`);
        this.updateLinks$.next();
      },
      error: (e) => {
        this.logger.logException(e);
        this.viewErrors(`Account - ${this.account.name}|${globals.validate_account}`);
      }
    });
  }

  private viewErrors(errorMessage: string) {
    this.dialogRef = this.dialog.open(ImportErrorsComponent, {
      data: {
        errorMessage: errorMessage
      },
      width: '600px'
    });

    this.dialogRef.afterClosed().subscribe({
      next: (data) => {
        this.authenticationService.signout();
      }
    });

    return firstValueFrom(this.dialogRef.afterClosed()
      .pipe(first()));
  }

  private updateLinks() {
    this._links = [
      {
        label: 'Dashboard',
        icon: 'navigation--home',
        routerLink: ['/training/home']
      },
      {
        label: 'home-divider',
        divider: true
      },
      {
        label: 'Trainer Console',
        icon: 'content--list',
        routerLink: ['/training/trainings']
      },
      {
        label: 'home-divider',
        divider: true,
        hidden: !this.isTrainerAdmin
      },
      {
        label: 'Health Stats',
        icon: 'reporting--report',
        routerLink: ['/training/healthstats'],
        children: [
          {
            label: 'Namespaces',
            icon: 'content--library',
            routerLink: ['/training/namespaces'],
          },
          {
            label: 'Active Folders',
            icon: 'ui--checklist',
            routerLink: ['/training/folders'],
          }
        ]
      },
      {
        label: 'home-divider',
        divider: true
      },
      {
        label: 'Accounts config',
        icon: 'configuration--account-management',
        routerLink: ['/training/accounts'],
        hidden: !this.isTrainerAdmin,
        children: [
          {
            label: globals.ACCOUNTS,
            icon: 'configuration--settings',
            routerLink: ['/training/accounts'],
          },
          {
            label: 'Account Access Tokens',
            icon: 'content--library',
            routerLink: ['/training/aat'],
          },
          {
            label: globals.ASSIGNMENTS,
            icon: 'ui--checklist',
            routerLink: ['/training/assignments'],
          }
        ],
      },
      {
        label: 'home-divider',
        divider: true,
        hidden: !this.isTrainerAdmin
      },
      {
        label: globals.MEMBERSHIPS,
        icon: 'users--manage-users',
        routerLink: ['/training/memberships'],
        hidden: !this.isTrainerAdmin
      },
      {
        label: 'home-divider',
        divider: true
      },
      {
        label: globals.IMPORTS,
        icon: 'configuration--color-settings',
        routerLink: ['/training/imports']
      },
      {
        label: 'home-divider',
        divider: true,
        hidden: !this.isTrainerAdmin
      },
      {
        label: globals.DATASETS,
        icon: 'content--payments',
        routerLink: ['/training/datasets'],
        hidden: !this.isTrainerAdmin
      },
      {
        label: 'home-divider',
        divider: true,
        hidden: !this.isTrainerAdmin
      },
      {
        label: globals.CONFIGURATIONS,
        icon: 'configuration--tools',
        routerLink: ['/training/configurations'],
        hidden: !this.isTrainerAdmin
      }
    ];
  }

  isTrainerAdmin: boolean;
  user: AuthenticatedUser;
  account?: AccountWithIcon;
  accounts?: string;
  _links: SideNavCollection[] = [];
  appName = globals.trainer_console;
  companyName = globals.company_name;
  helpLink = globals.help_link;
  homeLink = globals.home_link;
  
  private updateLinks$ = new Subject<void>();
  dialogRef: MatDialogRef<ImportErrorsComponent>;
}
